import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

const PopupBody = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="layer_body">
      {children}
    </div>
  );
});

PopupBody.displayName = 'PopupBody';

export default PopupBody;
